/**
 * return or create an entry for the specified page.
 *
 * it's essential that the draftState is wrapped in immer, in order for
 * mutations to be properly applied, as this function will create new entries if
 * none exist for the requested page.
 */
function getItemEntryById(page, itemId) {
  const entry = page.items[itemId];
  if (!entry) {
    const item = {};
    page.items[itemId] = item;
    return item;
  }
  return entry;
}

export { getItemEntryById };
//# sourceMappingURL=get-item-by-id.js.map
